import initializeCarouselForArticlePictures from "../common/functions/initializeCarouselForArticlePictures";
import initializeModalForArticlePictures from "../common/functions/initializeModalForArticlePictures";
import initializeStickyBottomOverlay from "../common/functions/initializeStickyBottomOverlay";

// NOTE: jQuery 3.x では $('selector').ready() がセレクタを無視して全ページで発火するため、
// $(function(){}) + 明示的なページガードに変更する
$(() => {
  if (!$("body.articles.show.pc").length) return;
  initializeCarouselForArticlePictures();
  initializeModalForArticlePictures();
  initializeStickyBottomOverlay();
});
